module.exports = __webpack_public_path__ + "static/media/1280px-PayPal_logo.svg.f0403966.png";